import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LeftMenuComponent } from './left-menu/left-menu.component';
import { HomeComponent } from './home/home.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { appConfig } from './app.config';
import { OAuthModule } from 'angular-oauth2-oidc';
import { NgxFileDropModule } from 'ngx-file-drop';
import {NgxPrintModule} from 'ngx-print';
import { NgxFileDragDropModule } from 'ngx-file-drag-drop';


@NgModule({
  declarations: [
    AppComponent,
    LeftMenuComponent,
    HomeComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    NgbModule,
    NgSelectModule,
    OAuthModule.forRoot(),
    NgxFileDropModule,
    NgxPrintModule,
    NgxFileDragDropModule
  ],
  providers: [
    provideClientHydration(),
    appConfig.providers,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
